export default __webpack_public_path__ + "static/media/2.e0a7e362.svg";